import React, { useEffect, useRef, useState } from 'react';
import './SyncStatus.css';

// Small, global "is my data saved?" indicator driven by the localStorage→server
// write-through queue (App.js dispatches `ira:sync` with the unsaved-write count).
// Shows Saving… while writes are in flight, flashes ✓ Saved when the queue drains,
// and warns ⚠ Not synced if writes don't clear within a few seconds. This makes the
// previously-invisible background save VISIBLE — important on iPhone, where dropped
// background writes used to fail silently.
export default function SyncStatus() {
  const [pending, setPending] = useState(() => (typeof window !== 'undefined' && window.__iraPendingCount ? window.__iraPendingCount() : 0));
  const [stuck, setStuck] = useState(false);
  const [savedFlash, setSavedFlash] = useState(false);
  const prev = useRef(pending);
  const stuckTimer = useRef(null);
  const flashTimer = useRef(null);

  useEffect(() => {
    const onSync = (e) => setPending((e.detail && e.detail.pending) || 0);
    window.addEventListener('ira:sync', onSync);
    return () => window.removeEventListener('ira:sync', onSync);
  }, []);

  useEffect(() => {
    if (pending > 0) {
      if (!stuckTimer.current) stuckTimer.current = setTimeout(() => setStuck(true), 6000);
    } else {
      if (stuckTimer.current) { clearTimeout(stuckTimer.current); stuckTimer.current = null; }
      setStuck(false);
      if (prev.current > 0) {   // queue just drained → confirm the save landed
        setSavedFlash(true);
        if (flashTimer.current) clearTimeout(flashTimer.current);
        flashTimer.current = setTimeout(() => setSavedFlash(false), 2000);
      }
    }
    prev.current = pending;
  }, [pending]);

  if (pending === 0 && !savedFlash) return null;
  let cls = 'syncstat saving', label = 'Saving…';
  if (pending === 0 && savedFlash) { cls = 'syncstat saved'; label = '✓ Saved'; }
  else if (stuck) { cls = 'syncstat stuck'; label = '⚠ Not synced — retrying'; }
  return <div className={cls} role="status" aria-live="polite">{label}</div>;
}
